export default __webpack_public_path__ + "static/media/img-0496-holy-see-full-face.3f41a535.png";